import { FuelImpact } from "@labs/shared/types/AnalyzedPlan.ts";

export const combineFuelImpacts = (fuelImpacts: FuelImpact[]): FuelImpact[] =>
  fuelImpacts.reduce<FuelImpact[]>((acc, impact) => {
    const existingImpact = acc.find(
      (item) => item.fuelSource === impact.fuelSource,
    );
    if (existingImpact) {
      existingImpact.carbonImpact += impact.carbonImpact;
    } else {
      acc.push({ ...impact });
    }
    return acc;
  }, []);
